export default __webpack_public_path__ + "static/0047-e75916b7654d5e365244abb1c782d58e.png";